module.exports = __webpack_public_path__ + "img/ps5.9302f0b7.jpg";